import React, { useState, useEffect } from 'react';
import { ColorPicker } from './ColorPicker';
import './CreateListForm.css';

interface CreateListFormProps {
  onSave?: (data: { name: string; description?: string; color?: string }) => void;
}

export const CreateListForm: React.FC<CreateListFormProps> = ({ 
  onSave
}) => {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [selectedColor, setSelectedColor] = useState<string | null>(null);

  // Check validation status
  const isNameValid = name.trim().length > 0;
  const isColorValid = selectedColor !== null;
  const isFormValid = isNameValid && isColorValid;

  // Expose current form data to parent
  const getCurrentData = () => ({
    name: name.trim(),
    description: description.trim() || undefined,
    color: selectedColor || undefined,
  });

  // Call onSave callback when form data changes
  useEffect(() => {
    if (onSave) {
      onSave(getCurrentData());
    }
  }, [name, description, selectedColor, onSave]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Form submission is handled by parent component via header button
  };

  return (
    <div className="create-list-form">
      <form onSubmit={handleSubmit} className="list-form">
        <div className="form-group">
          <input
            type="text"
            placeholder="List name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="list-input"
            autoFocus={window.innerWidth > 768}
            maxLength={100}
          />
        </div>

        <div className="form-group">
          <textarea
            placeholder="Description (optional)"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            className="list-textarea"
            rows={3}
            maxLength={500}
          />
        </div>

        <div className="form-group">
          <ColorPicker 
            selectedColor={selectedColor}
            onColorChange={setSelectedColor}
            showComment={true}
          />
        </div>

        {!isFormValid && (
          <div className="form-hint">
            {!isNameValid && !isColorValid && "Enter a name and choose a color to create your list"}
            {!isNameValid && isColorValid && "Enter a name to create your list"}
            {isNameValid && !isColorValid && "Choose a color to create your list"}
          </div>
        )}
      </form>
    </div>
  );
};
